const iconNames = [
	"angle-down",
	"angle-left",
	"angle-right",
	"angle-up",
	"mac",
	"arrow-left",
	"arrow-right",
	"arrow-to-bottom",
	"check",
	"chevron-down",
	"chevron-left",
	"chevron-right",
	"chevron-up",
	"clock",
	"copy",
	"debug",
	"long-arrow-left",
	"long-arrow-right",
	"play",
	"plus",
	"question-circle",
	"linux",
	"linux_rpm",
	"search",
	"shopping-cart",
	"sort",
	"times",
	"linux_deb",
	"user",
	"user-alt",
	"windows",
	"facebook-f",
	"twitter",
	"linkedin-in",
	"youtube",
	"facebook-square",
	"linkedin-square",
	"twitter-square",
	"youtube-alt",
	"dna",
	"book",
	"graduation-cap",
	"life-ring",
	"question",
	"question-circle-1",
	"video",
	"bullhorn",
	"file-star",
	"link-ext",
	"rocket-launch",
	"comments-alt",
	"instagram-square",
	"calendar-alt",
	"youtube-square",
];

export default iconNames;
